// 2026 design: segmented controls (markup in shared/_segmented_control.html.erb).
//
// Clicking a segment marks it pressed and, inside the control's scope, shows the
// elements whose data-seg-when lists the chosen value and hides the rest. The
// scope is the element named by data-seg-target, or else the nearest
// [data-seg-scope] ancestor. Presentation only: nothing is fetched or computed.
//
// One delegated listener on document, so Turbolinks page changes need no rebinding.
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-seg-control] [data-seg-value]');
  if (!button) return;

  const control = button.closest('[data-seg-control]');
  const value = button.dataset.segValue;

  control.querySelectorAll('[data-seg-value]').forEach(function (segment) {
    segment.setAttribute('aria-pressed', String(segment === button));
  });

  const scope = control.dataset.segTarget
    ? document.getElementById(control.dataset.segTarget)
    : control.closest('[data-seg-scope]');
  if (!scope) return;

  // Only elements that name at least one of THIS control's values are switched,
  // so two controls can share a scope (e.g. Net/Gross plus a round picker).
  const values = Array.from(control.querySelectorAll('[data-seg-value]')).map(function (s) { return s.dataset.segValue; });

  scope.dataset.segValue = value;
  scope.querySelectorAll('[data-seg-when]').forEach(function (element) {
    const when = element.dataset.segWhen.split(/\s+/);
    if (!when.some(function (v) { return values.includes(v); })) return;
    element.classList.toggle('hidden', !when.includes(value));
  });

  // Grouped table headings whose span depends on how many columns are showing,
  // e.g. data-seg-colspan="net:1 gross:1 both:2".
  scope.querySelectorAll('[data-seg-colspan]').forEach(function (element) {
    element.dataset.segColspan.split(/\s+/).forEach(function (pair) {
      const parts = pair.split(':');
      if (parts[0] === value) element.colSpan = Number(parts[1]);
    });
  });
});
